interface TableCheckboxProps {
    checked: boolean;
    index?: number;
    text?: string;
    onChange: () => void;
}

const TableCheckbox = ({ checked, index, onChange, text }: TableCheckboxProps) => {
    return (
        <button
            onClick={onChange}
            className={`
                flex justify-center items-center px-4 py-1 rounded-xl 
                border border-2 transition-all duration-400
            ${checked
                ? "bg-green-600 text-white border-gray-200"
                : "bg-transparent text-gray-300 border-gray-600"
            }
      `}
        >
            {/* Label */}
            {index !== undefined &&
                <span className="text-lg">{`${index}`}</span>
            }
            <span className="text-lg">{text}</span>
        </button>
    );
}

export default TableCheckbox;